export { LetterG as default } from './LetterG';
